import { config } from '../config';
export class EnvChecker {
    static checkRequired() {
        const issues = [];
        if (!config.api.baseUrl || config.api.baseUrl.includes('localhost')) {
            issues.push('API URL uses localhost - check production configuration');
        }
        if (!config.emails.company) {
            issues.push('Company email is not set');
        }
        return issues;
    }
}
const isDevelopment = process.env.NODE_ENV === 'development';
if (isDevelopment && typeof window !== 'undefined') {
    setTimeout(() => {
        EnvChecker.checkRequired();
    }, 1000);
}
